import { invitation } from '../data/invitation.js'
import { clockLabel, shortDateLabel, weddingMoment } from '../lib/weddingDate.js'
import styles from './Footer.module.css'

/**
 * 원본 마지막 블록. 신랑·신부 로마자 표기만 원본 그대로 남긴다 — `invitation`
 * 데이터 모델에 로마자 필드가 없다. 날짜·시각·장소는 예식일 하나에서 파생시킨다.
 */
export function Footer() {
  const moment = weddingMoment(invitation.weddingAt)
  return (
    <div className={styles.wrap}>
      <div className={styles.names}>
        Wooseok <span className={styles.heart}>♥</span> Yuna
      </div>
      <div className={styles.meta}>
        {shortDateLabel(moment)} {clockLabel(moment)} · {invitation.venue.name}
      </div>
    </div>
  )
}
